  window.initFeaturedProduct ?? (() => {
    window.initFeaturedProduct = (section_id) => {

        const featSliderSection = document.querySelector(`section#shopify-section-${section_id} .careline-20-featured-product`);

        const thumbsElement = featSliderSection.querySelector(
            '.alarm-watch-features__thumbs'
            );
        
        const swiperElement = featSliderSection.querySelector(
            '.alarm-watch-features'
            );

        const thumbsSwiper = new Swiper(thumbsElement, {
            slidesPerView: 3,
            spaceBetween: 14,
            watchSlidesProgress: true,
        });

        const swiper = new Swiper(swiperElement, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            navigation: {
                prevEl: featSliderSection.querySelector(
                    '.swiper-button-prev'
                ),
                nextEl: featSliderSection.querySelector(
                    '.swiper-button-next'
                )
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
            pagination: {
                el: featSliderSection.querySelector(
                    '.swiper-pagination'
                ),
            clickable: true
            }
        });

    }
  
})();
